import { render, staticRenderFns } from "./allClients.vue?vue&type=template&id=f95e2e94&scoped=true&"
import script from "./allClients.vue?vue&type=script&lang=js&"
export * from "./allClients.vue?vue&type=script&lang=js&"
import style0 from "./allClients.vue?vue&type=style&index=0&id=f95e2e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95e2e94",
  null
  
)

export default component.exports